import React, { useState, useContext } from "react";
import { PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Modal, Form } from "react-bootstrap";
import SubmitButton from "../StyledComponents/SubmitButton";

import exportToPdf from "../../lib/exportToPdf";
import exportToPdfReport from "../../lib/exportToPdfReport";

const ModalPdf = ({
  isReport,
  show,
  handleClose,
  chart,
  data,
  additionalNotes,
  days,
}) => {
  const [withoutNote, setWithoutNote] = useState(false);
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("dashboard.exportReport.header")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {t("dashboard.exportReport.bodyText", { days })}
        </p>
        <Form.Check
          name="withoutNote"
          type="checkbox"
          label={t("dashboard.exportReport.excludeSymptoms")}
          checked={withoutNote}
          style={{ fontWeight: "400", fontSize: "small" }}
          onChange={() => setWithoutNote(!withoutNote)}
        />
      </Modal.Body>
      <Modal.Footer>
        <SubmitButton
          onClick={() => {
            isReport ? exportToPdfReport(
              chart,
              data,
              days,
              additionalNotes,
              patient,
              withoutNote
            ) :
              exportToPdf(
                chart,
                data,
                days,
                additionalNotes,
                patient,
                withoutNote
              );
            handleClose();
          }}
        >
          {t("dashboard.exportReport.button")}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalPdf;